import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {colors} from '../colors/colors';
import {DynamicButtonContent} from '../dynamic-button-content/dynamic-button-content';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';
import {NotetakerIcon} from '../icon/svg/notetaker-icon';
// @ts-expect-error - imported from .js/.jsx file
import {StopIcon} from '../icon/svg/stop-icon';

import {AnimatingBars} from './animating-bars';

import styles from './transcribe-button.module.css';

type Props = {
    getRef: (ref?: HTMLButtonElement | null | undefined) => void;
    isTranscribing: boolean;
    isLoading: boolean;
    onClick: (e: React.SyntheticEvent<any>) => void;
};

export function TranscribeButton(props: Props) {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        const handleScroll = () => ReactTooltip.hide();
        window.addEventListener('scroll', handleScroll, true);

        return () => {
            ReactTooltip.hide();
            window.removeEventListener('scroll', handleScroll, true);
        };
    }, [props.isTranscribing, props.isLoading]);

    const buttonRef = React.useRef(null);

    const StartButtonContent = () => (
        <NotetakerIcon
            size={22}
            // @ts-expect-error
            onClick={(e) => {
                e.preventDefault();
                props.onClick(e);
            }}
            // @ts-expect-error
            onMouseDown={(e) => {
                e.preventDefault();
            }}
            fill={colors.plum}
            wrapWithDiv={false}
        />
    );

    const StopButtonContent = () => (
        <>
            {/* @ts-expect-error */}
            <NotetakerIcon size={22} fill={colors.plum} wrapWithDiv={false} />
            <AnimatingBars />
            <StopIcon size={16} fill={colors.rose} color={colors.rose} wrapWithDiv={false} />
        </>
    );

    return props.isTranscribing ? (
        <div className={styles['button-container']}>
            <button
                ref={(ref) => {
                    // @ts-expect-error
                    buttonRef.current = ref;
                    props.getRef(ref);
                }}
                data-tip='Stop taking notes'
                onClick={(e) => {
                    e.preventDefault();
                    props.onClick(e);
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                }}
                className={styles['stop-button']}
            >
                {/* @ts-expect-error */}
                <DynamicButtonContent
                    buttonRef={buttonRef}
                    defaultContent={<StopButtonContent />}
                    hoverContent={<StopButtonContent />}
                />
            </button>
        </div>
    ) : (
        <div className={styles['button-container']}>
            {props.isLoading ? (
                <LoadingIcon size={20} fill={colors.plum} wrapWithDiv={false} />
            ) : (
                <button
                    ref={(ref) => {
                        // @ts-expect-error
                        buttonRef.current = ref;
                        props.getRef(ref);
                    }}
                    data-tip='Start taking notes'
                    onClick={(e) => {
                        e.preventDefault();
                        props.onClick(e);
                    }}
                    onMouseDown={(e) => {
                        e.preventDefault();
                    }}
                    className={styles['start-button']}
                >
                    {/* @ts-expect-error */}
                    <DynamicButtonContent
                        buttonRef={buttonRef}
                        defaultContent={<StartButtonContent />}
                        hoverContent={<StartButtonContent />}
                    />
                </button>
            )}
        </div>
    );
}
